module.exports = __webpack_public_path__ + "img/icon-chevron-left-filled.8bd4456f.svg";